import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDate, asLabel, column, createdByField, field as plainField, lastModifiedByField, listColumnsOf, type Row, related, schemaRecord, text } from './kit';

const def = OBJECT_DEFS.contracts;

/**
 * Its fields come from the database (the server's SCHEMA_OBJECTS), shown by
 * their type, the Account, Opportunity and Parent Contract linked to their
 * records; any column not placed below appears in Other Fields (MOTHER-308).
 * Started by is the order that started it, which has no record page.
 */
const field = schemaRecord('contracts');

const details = [
  field('name', 'Contract Name'),
  field('type', 'Type'),
  field('account_name', 'Account'),
  field('opportunity_name', 'Opportunity'),
  field('parent_contract_name', 'Parent Contract'),
  field('status', 'Status'),
  field('start_date', 'Start'),
  field('end_date', 'End'),
  plainField('sales_order_name', 'Started by'),
  field('created_at', 'Created'),
  field('updated_at', 'Last Modified'),
  createdByField(),
  lastModifiedByField(),
];

/** The agreement an accepted order starts. Rationale: contracts.md. */
export const contracts: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Contract',
  plural: def.label,
  icon: def.icon,
  listColumns: listColumnsOf(def, details),
  details,
  sections: [
    {
      key: 'identity',
      fields: ['name', 'type', 'account_name', 'opportunity_name', 'parent_contract_name', 'status', 'start_date', 'end_date', 'sales_order_name'],
    },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [
    // Orders have no record page yet, so their names are not links.
    related('orders', 'Orders', undefined, [
      column('name', 'Order', { primary: true }),
      column('effective_date', 'Effective', { format: asDate }),
      column('status', 'Status', { format: asLabel }),
      column('source', 'Source', { format: asLabel }),
    ]),
  ],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'account_name', 'opportunity_name'],
};
